import { render, staticRenderFns } from "./CollapseHeight.vue?vue&type=template&id=1724051a&"
import script from "./CollapseHeight.vue?vue&type=script&lang=js&"
export * from "./CollapseHeight.vue?vue&type=script&lang=js&"
import style0 from "./CollapseHeight.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports